import { createContext, useContext, useState } from 'react'
import { COOKIE, getCookie } from '../services/Cookie';

const SiteContext = createContext();
const SiteContextUpdate = createContext();
const fullname = getCookie(COOKIE.FullName) ? getCookie(COOKIE.FullName) : ''

export function useSiteContext() { return useContext(SiteContext) }

export function useSiteContextUpdate() { return useContext(SiteContextUpdate) }

export function SiteContextProvider({ children }) {
	const [isDarkMode, setIsDarkMode] = useState(localStorage.getItem('theme') === 'true');
	const [username, setUsername] = useState(fullname);
	const [currentPage, setCurrentPage] = useState("");

	const handleThemeChange = () => {
		localStorage.setItem('theme', !isDarkMode)
		setIsDarkMode(prevState => !prevState);
	};

	return (
		<SiteContext.Provider value={{ isDarkMode, username, currentPage }}>
			<SiteContextUpdate.Provider value={{ handleThemeChange, setUsername, setCurrentPage }}>
				{children}
			</SiteContextUpdate.Provider>
		</SiteContext.Provider>
	);
}
